import Home from "./Default/Home";

export default Home;
